import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShoppingCartIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.43948 4.34961H3.375V6.14961H6.07509L8.92634 16.3093C8.33094 16.5537 7.91162 17.1392 7.91162 17.8227C7.91162 18.7257 8.6437 19.4578 9.54678 19.4578C10.3379 19.4578 10.9978 18.896 11.1492 18.1496H16.373C16.5245 18.896 17.1844 19.4578 17.9755 19.4578C18.8786 19.4578 19.6106 18.7257 19.6106 17.8227C19.6106 16.9196 18.8786 16.1875 17.9755 16.1875C17.7208 16.1875 17.4797 16.2457 17.2648 16.3496H10.8072L10.2229 14.2675H18.37L20.6248 7.50293H8.32443L7.43948 4.34961ZM9.76028 12.4675L8.86202 9.30293H18.1274L17.0726 12.4675H9.76028Z"
      />
    </SvgIcon>
  );
});
